export function isAdminUser(username: string): boolean {
  const adminUsernames = ["tn531", "greatk", "obiy"];
  return adminUsernames.includes(username);
}
